import { createAction } from 'redux-actions';
import {
  PapiRequestDaSharedTopicWatch,
  PapiRequestDaSharedTopicUnwatch,
  PapiRequestDaSharedTopicSuppress,
} from '@wix/da-papi-types';
import { actionKey } from './constants';

export const watchTopic = createAction(
  `${actionKey}/WATCH`,
  (params: PapiRequestDaSharedTopicWatch, onSuccess?: (res: any) => void) => ({
    params,
    onSuccess,
  })
);
export const watchTopicSuccess = createAction(
  `${actionKey}/WATCH_SUCCESS`,
  (params: PapiRequestDaSharedTopicWatch, response: any) => ({
    params,
    response,
  })
);
export const watchTopicFailure = createAction(
  `${actionKey}/WATCH_FAILURE`,
  (params: PapiRequestDaSharedTopicWatch) => ({ params })
);

export const unwatchTopic = createAction(
  `${actionKey}/UNWATCH`,
  (params: PapiRequestDaSharedTopicUnwatch, onSuccess?: (res: any) => void) => ({
    params,
    onSuccess,
  })
);
export const unwatchTopicSuccess = createAction(
  `${actionKey}/UNWATCH_SUCCESS`,
  (params: PapiRequestDaSharedTopicUnwatch, response: any) => ({
    params,
    response,
  })
);
export const unwatchTopicFailure = createAction(
  `${actionKey}/UNWATCH_FAILURE`,
  (params: PapiRequestDaSharedTopicUnwatch) => ({ params })
);

export const suppressTopic = createAction(
  `${actionKey}/SUPPRESS`,
  (params: PapiRequestDaSharedTopicSuppress, onSuccess?: (res: any) => void) => ({
    params,
    onSuccess,
  })
);
export const suppressTopicSuccess = createAction(
  `${actionKey}/SUPPRESS_SUCCESS`,
  (params: PapiRequestDaSharedTopicSuppress, response: any) => ({
    params,
    response,
  })
);
export const suppressTopicFailure = createAction(
  `${actionKey}/SUPPRESS_FAILURE`,
  (params: PapiRequestDaSharedTopicSuppress) => ({ params })
);
